import { render, staticRenderFns } from "./AffiliateSites.vue?vue&type=template&id=242fd7e4&"
import script from "./AffiliateSites.vue?vue&type=script&lang=js&"
export * from "./AffiliateSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports